import { formatMoney } from '@edil/api-client';
import type { Language } from '@edil/i18n';

export const money = (santim: string, currency = 'ETB') => formatMoney(santim, currency);

/** "4:05" / "1:02:30" / "2d 3h" until `target`, from a server-synced `now`. */
export function countdown(target: number, now: number): string {
  const s = Math.max(0, Math.floor((target - now) / 1000));
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (d > 0) return `${d}d ${h}h`;
  const two = (n: number) => String(n).padStart(2, '0');
  return h > 0 ? `${h}:${two(m)}:${two(sec)}` : `${m}:${two(sec)}`;
}

export function dateTime(iso: string, lang: Language): string {
  return new Intl.DateTimeFormat(lang === 'am' ? 'am-ET' : lang === 'om' ? 'om-ET' : 'en-GB', { dateStyle: 'medium', timeStyle: 'short', timeZone: 'Africa/Addis_Ababa' }).format(new Date(iso));
}

/**
 * The status label key for a round. A round that ended with no tickets sold had nothing to refund:
 * the room simply moved on to its next round, so it reads "Restarted" rather than "Refunded".
 */
export function roundStateKey(r: { state: string; tickets_sold: number }) {
  return (restarted(r) ? 'round.state.RESTARTED' : `round.state.${r.state}`) as never;
}
export const restarted = (r: { state: string; tickets_sold: number }) => r.state === 'REFUNDED' && r.tickets_sold === 0;

export function percent(x: number): string {
  return `${(x * 100).toFixed(x < 0.1 ? 1 : 0)}%`;
}

/** "Mozilla/5.0 (Macintosh…) Chrome/…" → "Chrome on macOS" for the device list. */
export function deviceName(userAgent: string | null): string {
  if (!userAgent) return 'Unknown device';
  const ua = userAgent;
  const browser = /Telegram/i.test(ua) ? 'Telegram' : /Edg\//.test(ua) ? 'Edge' : /OPR\//.test(ua) ? 'Opera' : /Firefox\//.test(ua) ? 'Firefox' : /Chrome\//.test(ua) ? 'Chrome' : /Safari\//.test(ua) ? 'Safari' : 'Browser';
  const os = /Android/.test(ua) ? 'Android' : /iPhone|iPad|iOS/.test(ua) ? 'iOS' : /Mac OS X|Macintosh/.test(ua) ? 'macOS' : /Windows/.test(ua) ? 'Windows' : /Linux/.test(ua) ? 'Linux' : '';
  return os ? `${browser} on ${os}` : browser;
}
